import useSWR from 'swr';
import api from '../services/api';
import { DETALHES_SWR_KEY } from './clearCache';

const EMPTY_DETALHES = [];

const fetcher = async () => {
  try {
    const response = await api.get('procedimento/convenio');
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || 'Erro ao buscar detalhes!');
  }
};

const useDetalhes = () => {
  const { data: detalhes = EMPTY_DETALHES, error, isLoading, mutate } = useSWR(
    DETALHES_SWR_KEY,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
    }
  );

  return {
    detalhes,
    isLoading,
    error,
    mutate,
  };
};

export default useDetalhes;
